import { Component, Input, EventEmitter, Output, OnInit} from '@angular/core';

/**
   * Logger Factory
   * @namespace title: tile to show
   * @namespace date: is the date to show
   * <ute-avatar class="image"  image="..." isEditable="true"></ute-avatar>
*/
@Component({
  selector: 'ute-cash-card',
  templateUrl: 'ute-cash-card.component.html',
})
export class UteCashCard implements OnInit{

  @Input() image: string;
  @Input() title: string;
  @Input() button: string;
  @Input() plan: string;
  @Input() description: string;
  @Input() price: string;
  @Input() expiration: any;
  @Output() buttonClick = new EventEmitter;
  @Output() buttonUpload = new EventEmitter;

  constructor() {

  }

  ionViewDidLoad(){
  }
  onButtonClick(event) {
    this.buttonClick.emit(this.title);
  }
  ngOnInit(){
    if(this.price){
      let p = parseFloat(this.price);
      this.price = p.toFixed(2);
    }
  }

  onButtonUploadClick(event) {
    this.buttonUpload.emit(this.title);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-cash-card/ute-cash-card.component.ts